import PropTypes from "prop-types";
import React from "react";

const Entity = ({ type, domain, children, onClick }) => {
  const domainTxt = ` @${domain}`;
  return (
    <span
      className={`${onClick ? "p-button--link" : ""}`}
      tabIndex={onClick ? 0 : -1}
      onClick={onClick}
      onKeyPress={onClick}
      role="button"
    >
      <i className={`p-icon--${type}`} />
      <span className="p-icon__text">
        {children}
        {domain && <span className="p-muted-text">{domainTxt}</span>}
      </span>
    </span>
  );
};

Entity.defaultProps = {
  children: "",
  onClick: undefined,
  domain: undefined
};

Entity.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["group", "user"]).isRequired,
  domain: PropTypes.string
};

export default Entity;
